import React, { useEffect, useRef, useState } from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import {
  REPORT_TYPES,
  TWITTERLEGENDS,
} from "../../../../constants/app-constant";
import { getSocialPlatformIdFromName } from "../../../../utility/common-methods";

require("highcharts/modules/exporting.js")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);
const {
  JournalistNOARanking,
  JournalistNOATrend,
  JournalistAnalysisPrint,
  SOV_NOA_TREND,
  JournalistTonalityNOARanking,
  PublicationNOATrend,
  TonalityNAORanking,
  PublicationNOARanking,
  CityWiseNOARanking,
  PLATFORM_RANK,
  Reach,
  PLATFORM_TREND,
  PLATFORM_TONALITY,
  TonalityNAOTrend,
  JournalistWCRanking,
  TonalityWordCount,
  TonalityWCTrend,
  TopPosters,
  EditionWiseNOATrend,
  MediaWiseNOARanking,
  ThematicAnalysisTag,
  ThematicAnalysisEntity,
} = REPORT_TYPES;

const convertToInternationalCurrencySystem = (labelValue) => {
  if (!labelValue) return "NA";
  // Nine Zeroes for Billions
  return Math.abs(Number(labelValue)) >= 1.0e9
    ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + "B"
    : // Six Zeroes for Millions
    Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
        ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + "K"
        : Math.abs(Number(labelValue));
};
const formatData = ({ datasets }) => {
  if (!datasets || !datasets.length) return;
  return datasets
    .map(({ label, data, backgroundColor }) => ({
      name: label,
      data: data && data.map((el) => parseInt(el)),
      color: backgroundColor,
    }))
    .sort((a, b) => parseFloat(b.data) - parseFloat(a.data));
};

const formatTwitterData = (data) => {
  if (!data) return;
  return TWITTERLEGENDS.map(({ name, color, entityname }) => {
    const newArray = data.map((x) => {
      const array = Object.keys(x).filter((el, index) => el == entityname);
      return parseInt(x[array]);
    });
    return {
      name: name,
      data: newArray,
      color: color,
    };
  });
};
export const VerticalBarChartHC = function ({
  graphApiResponse = { hcData: [{}] },
  onEntityClick,
  reportType,
  entityList,
  dataByReportType,
  editionList,
  isEmbededWidget,
  chartTitle,
  setGraphRef,
  setGraphRefList,
  showPercentage,
  mediaType,
  data,
  twitterFeeds,
}) {
  const ref = useRef();
  const labels = TWITTERLEGENDS.map(({ name }) => name);
  useEffect(() => {
    setGraphRef(ref);
  }, []);

  const [lineChartData, setLineChartData] = useState({});
  const showLegends =
    graphApiResponse &&
    graphApiResponse.datasets &&
    graphApiResponse.datasets.length;
  useEffect(() => {
    redrawChart();
  }, [graphApiResponse, showPercentage]);

  useEffect(() => {
    formatTwitterData(data);
  }, [data]);

  const showTolltip = () => {
    return (
      reportType === "38" ||
      reportType === "39" ||
      reportType === "40" ||
      reportType === "41"
    );
  };
  const tooltip =
    showTolltip() === false
      ? {
        formatter: function () {
          return (
            "The value for <b>" +
            this.x +
            "</b> is <b>" +
            this.series.name +
            "</b> is <b>" +
            convertToInternationalCurrencySystem(this.y) +
            "</b>"
          );
        },
      }
      : null;

  const customLabel = () => {
    if (/article/i.test(chartTitle) || /word/i.test(chartTitle))
      return "{value}";
    else return "{value}";
  };

  const redrawChart = () => {
    let graphData = !twitterFeeds
      ? formatData(graphApiResponse)
      : formatTwitterData(data);
    if (showPercentage) {
      const sumArray = [];

      for (let ele of graphData) {
        if (ele.data) {
          ele.data.forEach((val, ind) => {
            sumArray[ind] = (sumArray[ind] || 0) + val;
          });
        }
      }

      graphData = graphData.map((ele) => {
        ele.data = ele.data
          ? ele.data.map((val, ind) => {
            const percentVal = +((val * 100) / sumArray[ind]);
            return percentVal || 0;
            // return +((val * 100) / sumArray[ind]).toFixed(3);
          })
          : ele.data;
        return ele;
      });
    }
    const options = {
      chart: {
        type: "column",
      },
      legend: {
        enabled: !twitterFeeds ? showLegends : twitterFeeds,
        maxHeight: 65,
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      tooltip,
      exporting: {
        // showTable: true,
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
        },
      },
      series: graphData,
      plotOptions: {
        column: {
          dataLabels: {
            enabled: showTolltip() ? true : false,
            formatter: function () {
              return this.point.y.toFixed(2);
            },
          },
        },
        lang: {
          thousandsSep: ",",
        },
        series: {
          events: {
            click: (e) => handleBarClick(e),
          },
        },
      },
      xAxis: {
        categories: !twitterFeeds
          ? graphApiResponse.labels
          : labels && labels.length,
        labels: {
          style: {
            fontSize: "8px",
            textOverflow: "none",
          },
        },
      },
      yAxis: {
        tickPositions: showPercentage && [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        title: {
          text: null,
        },
        labels: {
          format: showPercentage ? "{value} %" : customLabel(),
        },
      },
    };
    setLineChartData(options);
    if (setGraphRefList) {
      setGraphRefList(reportType + mediaType, ref);
    }
  };

  const handleBarClick = (e) => {
    try {
      const {
        point: {
          category,
          series: { name },
        },
      } = e;
      const [label, legend] = [category, name];
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
        labels: null,
      };
      let clickedEntity = label;
      if (
        // /ranking/i.test(reportType) &&
        /sov/i.test(reportType) &&
        /entity/i.test(reportType)
      ) {
        clickedEntity = legend;
      }
      if (/sov/i.test(reportType) && /publication/i.test(reportType)) {
        routeParams.publication = legend;
      }
      if (/sov/i.test(reportType) && /geolocationNewEntity/i.test(reportType)) {
       
        clickedEntity = label;        
        routeParams.edition = legend;    
        
        // console.log("@@@@ routeParams:",routeParams);
      }  
      
      if (/sov/i.test(reportType) && /geolocationEntity/i.test(reportType)) {
       
        clickedEntity = label;        
        routeParams.zone = legend;    
        
        // console.log("@@@@ routeParams:",routeParams);
      } 
      if (/sov/i.test(reportType) && /Spokesperson/i.test(reportType)) {
        clickedEntity = label;        
        routeParams.spokesperson = legend;    
        // console.log("@@@@@ routeParams:",routeParams);    
      }
      if (/sov/i.test(reportType) && /Publication/i.test(reportType)) {
        clickedEntity = legend;        
        routeParams.publication = label;    
        //console.log("@@@@@ routeParams:",routeParams);    
      }
      if (/sov/i.test(reportType) && /SentimentNewEntity/i.test(reportType)) {
        //console.log("1111111111111111111111111111")
        clickedEntity = label;        
        routeParams.tonality = legend;
        routeParams.tonalityConditon = true;   
      }
      if (/sov/i.test(reportType) && /Thematic/i.test(reportType)) {
        clickedEntity = label;        
        routeParams.theme = legend;        
      }
      if (/trend/i.test(reportType)) {
        routeParams.date = label;
      }
      if (/sov/i.test(reportType) && /journalist/i.test(reportType)) {
        routeParams.sourceName = legend;
      }
      if (/sov/i.test(reportType) && /city/i.test(reportType)) {
        routeParams.edition = legend;
      }
      if (/sov/i.test(reportType) && /keyword/i.test(reportType)) {
        routeParams.keyword = legend;
      }
      if (/^Sentiment/.test(reportType)) {
        // console.log("Sentiment category",reportType);
        if (/Entity/.test(reportType)) {
          clickedEntity = label;
          routeParams.tonality = legend;
          routeParams.tonalityConditon = true;
        } else if (/City/.test(reportType)) {
          routeParams.edition = legend;
        } else if (/Publication/.test(reportType)) {
          routeParams.publication = legend;
        } else if (/Journalist/.test(reportType)) {
          routeParams.sourceName = legend;
        } else if (/Keyword/.test(reportType)) {
          routeParams.keyword = legend;
        }
      }
      // if (reportType === JournalistNOARanking) {
      //   routeParams.sourceName = label;
      //   if (isEmbededWidget) {
      //     let labelArray = label.split("[");
      //     routeParams.sourceName = labelArray
      //       .slice(0, labelArray.length - 1)
      //       .join("[");
      //   }
      // }
      // if (reportType === JournalistWCRanking) {
      //   routeParams.sourceName = label;
      // }
      // if (reportType === JournalistAnalysisPrint) {
      //   routeParams.sourceName = clickedEntity;
      // }
      // if (reportType === JournalistTonalityNOARanking) {
      //   const reporter = dataByReportType.find(
      //     (elm) => (elm.source_name = label)
      //   );
      //   routeParams.sourceName = reporter ? reporter.id : null;
      // }
      // if (reportType === PublicationNOARanking) {
      //   const clickedPublication = dataByReportType.filter(
      //     (elm) => elm.publication_name == label
      //   )[0];
      //   routeParams.publication = clickedPublication;
      // }
      // if (reportType === ThematicAnalysisTag) {
      //   const clickedCategory = dataByReportType.filter(
      //     (elm) => elm.category_name == label
      //   )[0];
      //   routeParams.categoryId = clickedCategory.category_id;
      // }
      // if (reportType === ThematicAnalysisEntity) {
      //   const entityClicked = dataByReportType.filter(
      //     (elm) => elm.entity_name == label
      //   )[0];

      //   if (entityClicked && entityClicked.data && entityClicked.data.length) {
      //     const clickedCategory = entityClicked.data.filter(
      //       (elm) => elm.category_name == legend
      //     )[0];
      //     routeParams.categoryId = clickedCategory.category_id;
      //   }
      // }

      // if (reportType == REPORT_TYPES.SOV) {
      //   routeParams.date = label;
      // }
      // if (
      //   reportType === CityWiseNOARanking ||
      //   reportType === EditionWiseNOATrend
      // ) {
      //   const clickedEdition = editionList.filter(
      //     (elm) => elm.edition_name == legend
      //   )[0];
      //   routeParams.edition = clickedEdition;
      // }
      // if (reportType === MediaWiseNOARanking) {
      //   const clickedEdition = editionList.filter(
      //     (elm) => elm.edition_name == label
      //   )[0];
      //   routeParams.edition = clickedEdition;
      // }
      // if (
      //   reportType === JournalistTonalityNOARanking ||
      //   reportType === TonalityNAORanking ||
      //   reportType === TonalityWordCount ||
      //   reportType === PLATFORM_TONALITY
      // ) {
      //   const tone = legend;
      //   routeParams.tonality = tone;
      // }
      // if (reportType == PLATFORM_RANK) {
      //   routeParams.channelType = getSocialPlatformIdFromName(label);
      // }
      // if (reportType == Reach) {
      //   routeParams.channelType = getSocialPlatformIdFromName(legend);
      // }

      // if (reportType == TopPosters) {
      //   routeParams.from_username = label.substring(1);
      // }

      let entity =
        entityList &&
        entityList.filter(
          (elm) =>
            clickedEntity == elm.entity_display_name?.trim() ||
            clickedEntity == elm.name || label == elm.entity_name?.trim()
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      routeParams.labels = legend.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div className={isEmbededWidget ? "biggerWidget" : ""}>
      <HighchartsReact
        highcharts={Highcharts}
        options={lineChartData}
        ref={ref}
      />
    </div>
  );
};

VerticalBarChartHC.defaultProps = {
  graphApiResponse: {},
  onEntityClick: () => { },
  reportType: "",
  entityList: [],
  dataByReportType: {},
  editionList: [],
  isEmbededWidget: false,
  chartTitle: "",
  setGraphRef: () => { },
  setGraphRefList: () => { },
};
